import { startPopupOpenAnimation, closePopupOpenAnimation } from './popup-animation'
import { pageLoaded } from '../site-config'
import { getBrowser } from '../utilities/browser-detection'

function setupVideoPopup()
{

  let jsVideoPopup = $('.js-video-popup')
  let popupContent = jsVideoPopup.find('.popup-content')
  let contentWidth = popupContent.width()
  let contentHeight = popupContent.height()
  popupContent.removeAttr('style')
  let ratioThreshold = 56.25;
  let currentRatio = popupContent.height() / popupContent.width()

  if(ratioThreshold > currentRatio && contentWidth > contentHeight) {
    popupContent.css('width', popupContent.height() + 'px')
  }

}

let videoPopup = $('.js-video-popup')
let videoPermalink = null
let changeCloseLink = false
let canChangeIframeSrc = true

$('body').on('click','.js-open-video-popup',function(e){

  if(!pageLoaded()) { return false}

  canChangeIframeSrc = false

  startPopupOpenAnimation($(this).find('.vdieo-el-img-c'))

  let url = $(this).attr('data-video')
  let iframeSrc = videoPopup.find('iframe').attr('src')

  if(url !== iframeSrc || iframeSrc.length === 0) {
    videoPopup.find('iframe').attr('src', url)
  }

  let link = $(this).attr('data-permalink')
  videoPermalink = $(this).attr('data-video-page')
  changeCloseLink = false
  if (typeof link !== typeof undefined && link !== false) {
    history.pushState({}, null, link);
    changeCloseLink = true
  }


})
$('body').on('click','.js-close-video-popup',function(){
  closeVideoPopup()
  if(changeCloseLink) {
    history.pushState({}, null, videoPermalink);
  }
  canChangeIframeSrc = true
})

$('body').on('click', function(event) {
  let $target = $(event.target);
  if($target.hasClass('js-close-video-target')) {
    closeVideoPopup()
  }
})

if(getBrowser().browser !== 'Explore') {

  $('body').on('mouseenter', '.js-open-video-popup', function (e){

    if(canChangeIframeSrc) {
      let url = $(this).attr('data-video')
      videoPopup.find('iframe').attr('src', url)
    }
  })

}

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closeVideoPopup()
  }
});

function closeVideoPopup()
{
  if(videoPopup.hasClass('open')){
    videoPopup.removeClass('open')
    let iframes = $('.js-popup').find('iframe')
    if (iframes.length){
      iframes.attr('src', '')
    }
    closePopupOpenAnimation()
  }
}


setupVideoPopup()


$( window ).resize(function() {
  setupVideoPopup()
});